import { Controller } from 'stimulus';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';
import SSTKAPI from '../../shutterstock-api';
import sendSSTKClickEvent from '../../shutterstock-analytics-listener';

export default class JustifiedResultsController extends Controller {
  static targets = [
    'apiResultsWrapper',
    'loadingAnim',
  ];

  connect() {
    this.loadingResults = false;

    this.element.addEventListener('click', sendSSTKClickEvent, { once: false });

    this.searchTerm = this.apiResultsWrapperTarget.getAttribute('data-keyword');
    this.resourceID = this.apiResultsWrapperTarget.getAttribute('data-resource-id');
    this.sstkSharedId = this.element.getAttribute('data-sstk-sharedid');
    this.sstkSubId1 = this.element.getAttribute('data-subid-one');

    this.sstk = new SSTKAPI(this.apiResultsWrapperTarget, this.searchTerm);

    this.sstkOptions = {
      page: 0,
      controllerElem: this.element,
      affiliate: this.apiResultsWrapperTarget.getAttribute('data-affiliate'),
      ird: this.apiResultsWrapperTarget.getAttribute('data-ird'),
      loc: this.apiResultsWrapperTarget.getAttribute('data-loc'),
      limit: this.apiResultsWrapperTarget.getAttribute('data-limit'),
      apiparams: this.apiResultsWrapperTarget.getAttribute('data-apiparams'),
      rowHeight: parseInt(this.apiResultsWrapperTarget.getAttribute('data-row-height'), 10),
      maxRows: this.apiResultsWrapperTarget.getAttribute('data-max-rows'),
      largeThumb: true,
      padResults: false,
      urlparams: this.sstk.makeUrlParams(this.sstkSharedId, this.sstkSubId1, this.resourceID),
    };

    this.getSSTKResults();

    const noResultTimer = setTimeout(() => {
      triggerCustomEvent(events.sponsored_search.without_results, { searchTerm: this.searchTerm });

      if (!this.element.querySelector('.ez-resource-thumb')) {
        this.element.parentNode.removeChild(this.element);
      }
    }, this.noResultsDelay);

    // TODO: Set up tracking here
    // delegate(document, 'click', '[data-target="sstk-justified-search.apiResultsWrapper"] li a', () => {
    //   track('similar_click', this.searchTerm, 'shutterstock');
    // });

    window.addEventListener('resultsLoaded', (event) => {
      if (event.detail !== 'END_OF_RESULTS') {
        window.clearTimeout(noResultTimer);
        window.addEventListener('scroll', this.loadNextResults);
      }
    }, { once: true });

    window.addEventListener('resultsLoaded', this.endLoadingResults);
  }

  disconnect() {
    this.element.removeEventListener('click', sendSSTKClickEvent, { once: false });
  }

  get noResultsDelay() {
    return 15 * 1000;
  }

  getSSTKResults() {
    this.loadingResults = true;

    this.addLoadingIndicator();

    this.sstk.getResults(this.sstkOptions);
  }

  endLoadingResults = (event) => {
    this.loadingResults = false;
    this.removeLoadingIndicator();

    if (event.detail === 'END_OF_RESULTS') window.removeEventListener('scroll', this.loadNextResults);
  }

  loadNextResults = () => {
    if (this.scrolledIntoView('.search-results__main')) {
      const displayedCount = this.element.querySelectorAll('li').length;
      const totalCount = this.apiResultsWrapperTarget.getAttribute('data-total-count');

      if (this.loadingResults === false && displayedCount < totalCount) {
        this.sstkOptions.page = this.sstkOptions.page + 1;

        this.getSSTKResults();
      }
    }
  }

  scrolledIntoView(selector) {
    const element = document.querySelector(selector);
    const docViewTop = window.pageYOffset || document.documentElement.scrollTop;
    const docViewBottom = docViewTop + window.innerHeight;
    const elementTop = element.offsetTop;
    const elementBottom = elementTop + (element.offsetHeight - 800);
    return elementBottom <= docViewBottom;
  }

  addLoadingIndicator() {
    this.loadingAnimTarget.classList.remove('is-hidden');
  }

  removeLoadingIndicator() {
    this.loadingAnimTarget.classList.add('is-hidden');
  }
}
